module.exports = __webpack_public_path__ + "static/media/Toby Frager.3d8d0112.jpeg";